import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputComponent } from '@shared/components/input/input.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-inputs',
	imports: [SharedModule, InputComponent, UiCodeBlockComponent],
	templateUrl: './ui-inputs.component.html',
	styleUrl: './ui-inputs.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiInputsComponent {
	inputControl = new FormControl('');
	disabledControl = new FormControl({ value: 'Disabled value', disabled: true });

	generateCode(attrs: {
		formControl?: string;
		placeholder?: string;
		label?: string;
		helperText?: string;
		icon?: string;
		iconPosition?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
	}): string {
		let code = '<app-input';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.helperText) code += `\n    helperText="${attrs.helperText}"`;
		if (attrs.icon) code += `\n    icon="${attrs.icon}"`;
		if (attrs.iconPosition) code += `\n    iconPosition="${attrs.iconPosition}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;

		code += '\n/>';
		return code;
	}
}
